// GN: selo "Cupom de primeira compra" + pop-up de captura que libera o cupom (só para visitantes não logados).
if (!customElements.get('gn-primeira-compra')) {
  customElements.define(
    'gn-primeira-compra',
    class GnPrimeiraCompra extends HTMLElement {
      static CHAVE = 'gn-cupom-primeira-compra';

      connectedCallback() {
        this.janela = this.querySelector('dialog');
        this.form = this.querySelector('.gn-pc__form');
        this.erro = this.querySelector('.gn-whatsapp__erro');
        this.codigo = this.dataset.codigo;
        this.querySelector('.gn-pc__selo').addEventListener('click', () => this.abrir());
        this.form.addEventListener('submit', (e) => this.enviar(e));
        this.form.whatsapp.addEventListener('input', (e) => (e.target.value = this.mascara(e.target.value)));
        this.querySelector('.gn-pc__copiar').addEventListener('click', (e) => this.copiar(e.currentTarget));
        this.querySelector('.gn-pc__continuar').addEventListener('click', () => this.janela.close());
        this.janela.addEventListener('click', (e) => e.target === this.janela && this.janela.close());
      }

      jaGanhou() {
        try {
          return JSON.parse(localStorage.getItem(GnPrimeiraCompra.CHAVE));
        } catch (e) {
          return null;
        }
      }

      abrir() {
        const salvo = this.jaGanhou();
        this.mostrar(salvo ? 'cupom' : 'dados', salvo && salvo.nome);
        this.janela.showModal();
        if (!salvo) this.form.nome.focus();
      }

      mostrar(passo, nome) {
        this.querySelectorAll('.gn-pc__passo').forEach((el) => (el.hidden = el.dataset.passo !== passo));
        if (passo === 'cupom') this.querySelector('.gn-pc__nome').textContent = nome ? ', ' + nome.split(' ')[0] : '';
      }

      mascara(valor) {
        const d = valor.replace(/\D/g, '').slice(0, 11);
        if (d.length <= 2) return d.length ? `(${d}` : '';
        if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
        if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
        return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
      }

      validar(d) {
        if (d.nome.length < 2) return 'Informe seu nome.';
        const digitos = d.whatsapp.replace(/\D/g, '');
        if (digitos.length < 10 || digitos.length > 11) return 'Informe um WhatsApp válido com DDD.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) return 'Informe um e-mail válido.';
        if (!d.aceita_whatsapp) return 'Para receber o cupom, aceite receber mensagens pelo WhatsApp.';
        if (!d.aceita_termos) return 'Para receber o cupom, aceite os termos de serviço.';
        return '';
      }

      async enviar(evento) {
        evento.preventDefault();
        const dados = {
          nome: this.form.nome.value.trim(),
          pet: this.form.pet.value.trim(),
          whatsapp: this.form.whatsapp.value.trim(),
          email: this.form.email.value.trim(),
          aceita_whatsapp: this.form.aceita_whatsapp.checked,
          aceita_termos: this.form.aceita_termos.checked,
        };
        const problema = this.validar(dados);
        this.erro.hidden = !problema;
        this.erro.textContent = problema;
        if (problema) return;

        const botao = this.form.querySelector('.gn-pc__enviar');
        botao.disabled = true;
        const registro = {
          ...dados,
          whatsapp_digitos: '55' + dados.whatsapp.replace(/\D/g, ''),
          pagina: location.href,
          origem: 'cupom-primeira-compra',
          data: new Date().toISOString(),
        };

        // Mesma planilha do pop-up do WhatsApp (URL configurada na seção do WhatsApp)
        const webhook = document.querySelector('gn-whatsapp')?.dataset.webhook;
        const envios = [
          // Já deixa o cupom aplicado para o checkout
          fetch((window.Shopify?.routes?.root || '/') + 'discount/' + encodeURIComponent(this.codigo), {
            credentials: 'same-origin',
          }),
        ];
        if (webhook) {
          envios.push(
            fetch(webhook, {
              method: 'POST',
              mode: 'no-cors',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify(registro),
            })
          );
        }
        await Promise.race([Promise.allSettled(envios), new Promise((r) => setTimeout(r, 2500))]);

        try {
          localStorage.setItem(GnPrimeiraCompra.CHAVE, JSON.stringify({ nome: dados.nome, pet: dados.pet, data: registro.data }));
          // O botão do WhatsApp não pede os dados de novo
          localStorage.setItem('gn-whatsapp-contato', JSON.stringify({ nome: dados.nome, pet: dados.pet, data: registro.data }));
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('gn:primeira-compra-lead', { detail: registro }));
        botao.disabled = false;
        this.mostrar('cupom', dados.nome);
      }

      async copiar(botao) {
        const original = botao.textContent;
        try {
          await navigator.clipboard.writeText(this.codigo);
        } catch (e) {
          // Navegadores sem clipboard API: seleciona o texto para o cliente copiar
          const r = document.createRange();
          r.selectNodeContents(this.querySelector('.gn-pc__codigo-texto'));
          const s = window.getSelection();
          s.removeAllRanges();
          s.addRange(r);
          document.execCommand && document.execCommand('copy');
        }
        botao.textContent = botao.dataset.copiado;
        botao.classList.add('is-copiado');
        setTimeout(() => {
          botao.textContent = original;
          botao.classList.remove('is-copiado');
        }, 2000);
      }
    }
  );
}
